export default __webpack_public_path__ + "static/media/12week-Promo.1af59f7b.mp4";